// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3CvB6","tab":"ProcedureTabs_tab__z6a-p"};